import { runChunkedExport } from '../../index.js';
/** Surface-authenticated transport. The caller unwraps the API data envelope. */
export function createExportApi(request) {
    const exportTo = (provider, data) => runChunkedExport(data.ticketIds, ticketIds => request(`/integrations/${provider}/export`, {
        method: 'POST', body: JSON.stringify({ ...data, ticketIds }),
    }));
    return {
        list: () => request('/integrations'),
        initiateAuth: provider => request(`/integrations/${provider}/auth`, { method: 'POST' }),
        getJiraProjects: () => request('/integrations/jira/projects'),
        getJiraIssueTypes: (cloudId, projectKey) => request(`/integrations/jira/issue-types?${new URLSearchParams({ cloudId, projectKey })}`),
        getLinearTeams: () => request('/integrations/linear/teams'),
        getLinearProjects: teamId => request(`/integrations/linear/projects?${new URLSearchParams({ teamId })}`),
        getAsanaWorkspaces: () => request('/integrations/asana/workspaces'),
        getAsanaProjects: workspaceGid => request(`/integrations/asana/projects?${new URLSearchParams({ workspaceGid })}`),
        getTrelloBoards: () => request('/integrations/trello/boards'),
        getTrelloLists: boardId => request(`/integrations/trello/boards/${encodeURIComponent(boardId)}/lists`),
        getGitHubRepositories: () => request('/integrations/github/repositories'),
        exportToGitHub: data => exportTo('github', data),
        getClickUpWorkspaces: () => request('/integrations/clickup/workspaces'),
        getClickUpSpaces: workspaceId => request(`/integrations/clickup/spaces?${new URLSearchParams({ workspaceId })}`),
        getClickUpLists: spaceId => request(`/integrations/clickup/lists?${new URLSearchParams({ spaceId })}`),
        getBasecampProjects: () => request('/integrations/basecamp/projects'),
        getBasecampTodolists: (accountId, projectId) => request(`/integrations/basecamp/todolists?${new URLSearchParams({ accountId, projectId })}`),
        getMondayBoards: () => request('/integrations/monday/boards'),
        getMondayGroups: boardId => request(`/integrations/monday/groups?${new URLSearchParams({ boardId })}`),
        getProjectSchema: (provider, projectId, opts) => {
            const collection = { linear: 'teams', jira: 'projects', asana: 'projects', notion: 'databases', trello: 'boards', clickup: 'lists', github: 'repositories', basecamp: 'todolists', monday: 'boards' }[provider];
            return request(`/integrations/${provider}/${collection}/${encodeURIComponent(projectId)}/schema${opts ? `?${new URLSearchParams(opts)}` : ''}`);
        },
        exportToJira: data => exportTo('jira', data),
        exportToLinear: data => exportTo('linear', data),
        exportToAsana: data => exportTo('asana', data),
        exportToTrello: data => exportTo('trello', data),
        exportToClickUp: data => exportTo('clickup', data),
        exportToBasecamp: data => exportTo('basecamp', data),
        exportToMonday: data => exportTo('monday', data),
        exportToNotion: data => exportTo('notion', data),
    };
}
//# sourceMappingURL=createExportApi.js.map